import _ from 'underscore';
const viewingOwnAnalytics =
  $a.is_logged_in() && Aedu.User.current.id === Aedu.User.viewed.id;
const isPremium = $a.is_logged_in() && Aedu.User.current.premium;
const canViewFreeImpactReport =
  $a.is_logged_in() && Aedu.canViewFreeImpactReport;
const canSeeTwelveMonthsImpact =
  $a.is_logged_in() && Aedu.canSeeTwelveMonthsImpact;

let mode = (function () {
  if (!viewingOwnAnalytics) {
    return 'restricted';
  }

  if (isPremium) {
    return 'premium';
  } else {
    return 'upgradeable';
  }
})();

// now maybe override for admin debugging
if ($a.is_admin()) {
  const param = $a.query_param('show_as');
  if (param) {
    mode = param;
  }
}

const inMode = (...args) => _.contains(args, mode);

const exportObj = {
  inMode,
  mode,
  isOwner: viewingOwnAnalytics,
  canViewFreeImpactReport: canViewFreeImpactReport,
  canSeeTwelveMonthsImpact: canSeeTwelveMonthsImpact,
};

export default exportObj;
export { exportObj as Permissions };
export {
  inMode,
  mode,
  viewingOwnAnalytics as isOwner,
  canViewFreeImpactReport,
  canSeeTwelveMonthsImpact,
};
